export const PACKING_MATERIAL_TYPES = {
    PROTECTION_MATERIAL: "PROTECTION_MATERIAL"
}
